import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vue3TelInput from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";
import VueApexCharts from "vue3-apexcharts";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

createApp(App)
  .use(store)
  .use(router)
  .use(Vue3TelInput)
  .use(VueApexCharts)
  .mount("#app");
